<template>
  <div class="container-xl">
    <div class="row">
      <!-- <div class="col-sm-6 col-lg-3 cursor-pointer" @click="show.modal_histories = true" v-loading="loading.balance">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="subheader"></div>
            </div>
            <div class="h1 mb-3">Rp. {{ ewa_balance?.toLocaleString() || 0 }}</div>
            <div class="d-flex mb-2">
              <div>AWA Wallet Balance</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="col-sm-6 col-lg-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="subheader"></div>
            </div>
            <div class="h1 mb-3">{{ summary.total_request || 0 }}</div>
            <div class="d-flex mb-2">
              <div>Total Requested</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="subheader"></div>
            </div>
            <div class="h1 mb-3">{{ summary.total_amount_str || '-' }}</div>
            <div class="d-flex mb-2">
              <div>Total Amount</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="subheader"></div>
            </div>
            <div class="h1 mb-3">{{ summary.total_admin_fee_str || '-' }}</div>
            <div class="d-flex mb-2">
              <div>Total Admin Fee</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="subheader"></div>
            </div>
            <div class="h1 mb-3">{{ summary.total_upfront_fee_str || '-' }}</div>
            <div class="d-flex mb-2">
              <div>Total UpFront Fee ( insurance + processing )</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card col-lg-12 mt-2">
      <b-tabs :value="current_active_index">
        <b-tab :active-id="index.toString()" v-for="(opt, index) in tab_options" :key="index" :title="opt.name" @click="handlerStatusFilter(opt.value)">
          <div class="card-header justify-content-between">
            <div class="card-title">
              AWA {{ opt.name }} List
            </div>
            <div class="flex flex-row mb-2 pr-2 float-right">
              <div class="m-2">
                <i class="el-icon-refresh" @click="getList()"></i> 
              </div>
              <el-input clearable @clear="searchHandler" style="width: 200px" size="small" type="text" v-model="search_keyword" placeholder="Input Company Name" class="mr-2"/>
              <el-button type="primary" @click="searchHandler" size="small"><font-awesome-icon icon="search"/> Search</el-button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table card-table text-nowrap table-vcenter">
              <thead>
                <tr>
                  <th width="30%">Company Name</th>
                  <!-- del -->
                  <!-- <th width="40%">Bank Account Name</th>
                  <th width="40%">Bank Account Number</th>
                  <th width="40%">Bank ID</th> -->
                  <th width="10%">Total Recipient</th>
                  <th width="20%">Total Requested Amount</th>
                  <th width="20%">Total Admin Fee</th>
                  <th width="20%">Total Upfront Fee</th>
                  <th width="10%">#</th>
                </tr>
              </thead>
              <tbody v-loading="is_loading">
                <tr v-for="(item, i) in list" :key="i">
                  <td>{{ item.company.name }}</td>
                  <!-- <td>{{ item.bank_account_name }}</td>
                  <td>{{ item.bank_account_number }}</td>
                  <td>{{ item.bank_id }}</td> -->
                  <td>{{ item.total_request }} recipient(s)</td>
                  <td>{{ item.total_amount_str }}</td>
                  <td>{{ item.total_admin_fee_str }}</td>
                  <td>{{ item.total_upfront_fee_str }}</td>
                  <td>
                    <el-button round v-if="(isChecker && opt.value == 'WAITING_DISBURSEMENT') || (isMaker && opt.value == 'WAITING_APPROVAL')" @click="handlerBtnApprove(item, opt.value)" type="success" size="mini">
                      <font-awesome-icon icon="check"/>
                    </el-button>
                    <!-- <el-button round v-if="isChecker && opt.value == 'WAITING_DISBURSEMENT'" size="mini" @click="handlerBtnReject(item, opt.value)" type="danger"> -->
                    <el-button round v-if="isChecker && opt.value == 'WAITING_APPROVAL'" size="mini" @click="handlerBtnReject(item, opt.value)" type="danger">
                      <font-awesome-icon icon="times-circle"/>
                    </el-button>
                    <!-- <el-button round v-if="isChecker && opt.value == 'WAITING_DISBURSEMENT'" size="mini" @click="handlerBtnRollback(item, opt.value)" type="danger">
                      <font-awesome-icon icon="times-circle"/> rollback
                    </el-button> -->
                    <el-button round size="mini" @click="handlerBtnView(item.company_id, opt.value, opt.value == 'WAITING_APPROVAL' ? 'approved' : null)" type="info">
                      <font-awesome-icon icon="address-book"/>
                    </el-button>
                    <el-button v-if="opt.value == 'COMPLETED'" alt="View Invoice" round size="mini" @click="handlerBtnViewInvoice(item.company_id, item.company.name)" type="primary">
                      <font-awesome-icon icon="file-invoice"/>
                    </el-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <el-empty description="No AWA request for now" v-if="!total_rows" :image="emptyStateImage"></el-empty>
          </div>
          <pagination
            :page="page"
            :per_page="per_page"
            :list="list"
            :total_rows="total_rows"
            @pageChange="pageChangeHandler" />
        </b-tab>
      </b-tabs>
    </div>
    <b-modal size="md" v-model="show.modal_ewa" title="Approve AWA" hide-footer>
    <div v-if="disburse.auto_disburse" class="flex items-center p-2 mb-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400" role="alert">
      <svg class="shrink-0 inline w-3 h-3 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
      </svg>
      <span class="sr-only">Info</span>
      <div>
        <span class="font-medium">Disbursed by system activated</span>
      </div>
    </div>

    <div v-else class="flex items-center p-2 mb-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400" role="alert">
      <svg class="shrink-0 inline w-3 h-3 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
      </svg>
      <span class="sr-only">Info</span>
      <div>
        <span class="font-medium">Disbursement by system deactivated </span>
      </div>
    </div>
      <el-descriptions :loading="loading.modal_ewa" class="margin-top" title="" :column="1" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            Company Name
          </template>
          {{ selected_ewa.company_name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i><font-awesome-icon icon="users" size="sm"/></i>
            Total AWA Request
          </template>
          {{ selected_ewa.total_request }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i><font-awesome-icon icon="money-bill-alt" size="sm"/></i>
            Total AWA Amount
          </template>
          {{ selected_ewa.total_amount_str }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i><font-awesome-icon icon="hand-holding-usd" size="sm"/></i>
            Total Admin Fee
          </template>
          {{ selected_ewa.total_admin_fee_str }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i><font-awesome-icon icon="hand-holding-usd" size="sm"/></i>
            Total Upfront Fee
          </template>
          {{ selected_ewa.total_upfront_fee_str }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i><font-awesome-icon icon="money-bill-wave" size="sm"/></i>
            Total Disburse Amount
          </template>
          {{ `Rp ${this.disburse.total_disburse_amount.toLocaleString('id-ID')}` }}
        </el-descriptions-item>
        <!-- v-if="status_filter === 'waiting_disbursement'" -->
        <!-- <el-descriptions-item v-if="sh      ouldDisplayPaymentReceiptForm">
          <template slot="label">
            <i><font-awesome-icon icon="money-bill-wave" size="sm"/></i>
            Auto Disbuse
          </template>
          {{ disburse.auto_disburse }}
        </el-descriptions-item> -->
        <el-descriptions-item v-if="shouldDisplayPaymentReceiptForm && !disburse.auto_disburse">
          <template slot="label">
            <i><font-awesome-icon icon="money-bill-wave" size="sm"/></i>
            Payment Confirmation Receipt
          </template>
          <b-form-file
            v-model="selected_file.payment_confirm_file"
            :state="Boolean(selected_file.payment_confirm_file)"
            class="mt-2 border-1 p-2"
            accept=".png, .jpg, .jpeg"
            @input="onChangeFile($event, 'payment_confirm_file')"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
            <img ref="payment_confirm_file" :src="test.payment_confirm_file"/>
        </el-descriptions-item>
      </el-descriptions>
      <div class="d-flex float-right mt-2">
        <el-button class="mr-2 ml-2" @click="submit_approval" size="small" type="primary">Submit</el-button>
        <el-button @click="show.modal_ewa = false" size="small" class="mr-2">Cancel</el-button>
      </div>
    </b-modal>
    <awa-balance-histories :isShown="show.modal_histories"/>
  </div>
</template>
<script>
import {
   INQUIRY_APPROVAL, SUBMIT_APPROVAL, REJECT_AWA , ROLLBACK_APPROVAL, CHECK_EWA_BALANCE, GET_AWALIST_FINANCE
} from '@/store/modules/awa';
import emptyStateImage from '@/assets/images/empty-state.png';
import popupErrorMessages from '@/library/popup-error-messages';
import Pagination from '../components/Pagination.vue';
import AwaBalanceHistories from './awa/BalanceHistories.vue';
import imageCompress from '@/library/vue-image-compression';
import base64File from '@/library/base64File';

export default {
  name: 'AWA',
  components: {
    Pagination,
    AwaBalanceHistories,
  },
  metaInfo: {
    title: 'Advanced Wage Access',
  },
  computed: {
    showingFrom() {
      return this.total_rows ? ((this.page - 1) * this.per_page) + 1 : 0;
    },
    showingUntil() {
      if (this.total_rows) {
        if (this.list.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
    isTabWaitingActive() {
      return this.$route.query.tab === '';
    },
    isTabApproveActive() {
      return this.$route.query.tab === 'COMPLETED';
    },
    currentRole() {
      return this.$store.getters.current_role;
    },
    userProfile() {
      return this.$store.getters.currentMyProfile;
    },
    isMaker() {
      return this.userProfile.is_maker || this.currentRole.page_name === '*';
    },
    isChecker() {
      return this.userProfile.is_checker || this.currentRole.page_name === '*';
    },
    shouldDisplayPaymentReceiptForm() {
      return this.selected_ewa.current_state === 'WAITING_DISBURSEMENT' &&
            this.tab_options.some(tab => tab.value === 'WAITING_DISBURSEMENT');
    },
  },
  data() {
    return {
      disburse: {
        approval_id: "",
        total_amount: 0,
        total_admin_fee: 0,
        total_processing_fee: 0,
        total_insurance_fee: 0,
        total_upfront_fee: 0,
        auto_disburse: false,
        total_disburse_amount: 0
      },
      search_keyword: '',
      search_by: '',
      emptyStateImage,
      is_loading: false,
      total_rows: 0,
      page: 1,
      per_page: 10,
      list: [],
      show: {
        modal_ewa: false,
        modal_histories: false,
      },
      loading: {
        modal_ewa: false,
        balance: true,
      },
      selected_ewa: {},
      selected_file: {
        // promo_image_url: null,
        payment_confirm_file: null,  
        payment_confirm_file_base64: null,  
    },
    test: {
        payment_confirm_file: '',  
    },
    filter_value: 'WAITING_APPROVAL',
    current_active_index: 0,
    tab_options: [
      {
        name: 'Waiting Approval',
        value: 'WAITING_APPROVAL',
      },
      {
        name: 'Waiting Disbursement',
        value: 'WAITING_DISBURSEMENT',
      },
      {
        name: 'Approved',
        value: 'COMPLETED',
      },
    ],
    summary: {},
    ewa_balance: 0,
    file_tmp: '',
  };
  },
  beforeMount() {
    const i = this.tab_options.findIndex((v) => v.value === this.filter_value);
    this.current_active_index = i;
  },
  async mounted() {
    if (this.$route.query.tab) {
      this.filter_value = this.$route.query.tab;
    }
    await this.getList();
    // this.ewaBalance();
  },
  methods: {
    searchHandler() {
      this.page = 1;
      this.getList();
    },
    async handlerStatusFilter(value) {
      this.filter_value = value;
      if (this.filter_value !== this.$route.query.tab) {
        this.$router.replace({
          name: 'AWA',
          query: {
            tab: value,
          },
        });
      }
      this.page = 1;
      this.list = [];
      this.total_rows = 0;
      this.is_loading = true;
      await this.getList();
      this.is_loading = false;
    },
    async pageChangeHandler(page) {
      this.page = page;
      this.is_loading = true;
      await this.getList();
      this.is_loading = false;
    },
    async getList() {
      try {
        this.$parent.showLoader();
        const payload = {
          page: this.page,
          per_page: this.per_page,
          filter_by: "disburse_status",
          filter_value: this.filter_value,
          search:  "company_name",
          search_value: this.search_keyword
        };
        await this.$store.dispatch(GET_AWALIST_FINANCE, payload);
        this.$parent.hideLoader();
        const storeData = this.$store.getters.awa_list_finance || {};
        const summary = storeData.data?.summary || {};
        const count = storeData.data?.count || 0;
        const companies = storeData.data?.companies || [];
        this.current_active_index = this.tab_options.findIndex((v) => v.value === this.filter_value);
        this.total_rows = count;
        this.list = companies;
        this.companies = summary;
        this.summary.total_amount_str = `Rp. ${(summary.total_amount || 0).toLocaleString()}`;
        this.summary.total_admin_fee_str = `Rp. ${(summary.total_admin_fee || 0).toLocaleString()}`;
        this.summary.total_disburse_amount_str = `Rp. ${(summary.total_disburse_amount || 0).toLocaleString()}`;
        this.summary.total_upfront_fee_str = `Rp. ${( summary.total_upfront_fee|| 0 ).toLocaleString()}`;
      } catch (error) {
        this.$parent.hideLoader();
      }
    },
    handlerBtnApprove(item, current_state) {
      this.show.modal_ewa = true;
      this.selected_ewa = item;
      this.selected_ewa.action = current_state === 'WAITING_APPROVAL' ? 'WAITING_DISBURSEMENT' : 'disburse';
      this.selected_ewa.current_state = current_state;
      this.inquiry();
    },

    async inquiry() {
      this.loading.modal_ewa = true;

      const ownedBy = this.selected_ewa?.owned_by ? this.selected_ewa.owned_by.toString() : "";

      const payload = {
        id: this.selected_ewa.company_id,
        data: {
          current_state: this.selected_ewa.current_state,
          approval_type: "batch"
        },
      };
      try {
        const response = await this.$store.dispatch(INQUIRY_APPROVAL, payload);
        const result = response.data;
        this.disburse = {
          approval_id: result.approval_id,
          total_amount: result.total_amount,
          total_admin_fee: result.total_admin_fee,
          total_processing_fee: result.total_processing_fee,
          total_insurance_fee: result.total_insurance_fee,
          total_upfront_fee: result.total_upfront_fee,
          auto_disburse: result.auto_disburse,
          total_disburse_amount: result.total_disburse_amount
        };
        this.selected_ewa.approval_id = result.approval_id;
      } catch (error) {
      } finally {
        this.loading.modal_ewa = false;
      }
    },
    async submit_approval() {
      if (
        this.shouldDisplayPaymentReceiptForm &&
        !this.disburse.auto_disburse && 
        !this.selected_file.payment_confirm_file
      ) {
        this.$message.error('Please upload the Payment Confirmation Receipt file.');
        return;
      }
      this.$confirm(
        'You will approve this AWA disbursement batch. You cannot undo this action. Continue?',
        'Confirmation',
        {
          type: 'info',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              try {
                let data = {
                  approval_id: this.disburse.approval_id,
                  user_id : null,
                  approval_type : "batch"
                  // inssurance : 15rb
                };

                if (this.filter_value === 'WAITING_DISBURSEMENT' && !this.disburse.auto_disburse) {
                  data.payment_confirm_file = this.file_tmp;
                }

                await this.$store.dispatch(SUBMIT_APPROVAL, {
                  id: this.selected_ewa.company_id,
                  data: data,
                  // owned_by: this.selected_ewa.owned_by
                });

                this.$message({
                  title: 'Success',
                  type: 'success',
                  message: 'Approval success',
                });

                this.show.modal_ewa = false;
                this.getList();
              } catch (err) {
                if (err.response?.data) {
                  popupErrorMessages(err.response.data);
                }
              }
              instance.confirmButtonLoading = false;
            }
            done();
          },
        }
      ).catch(() => {});
    },
    async onChangeFile(event, target) {
      // console.log('target ==>', target)
      if (this.selected_file[target]) {
        const compressed = await imageCompress(this.selected_file[target]);
        this.selected_file[`${target}_base64`] = await base64File(compressed);
        this.file_tmp = this.selected_file[`${target}_base64`]
      }
    },
    async handlerBtnView(company_id, status, approval_status) {
        this.$router.push({
          name: 'AWA Detail',
          params: {
            id: company_id,
            status,
          },
          query: {
            approval_status,
          },
        });
    },
    handlerBtnReject(item, current_state) {
      const obj = {
        owned_by: null,
        current_state: current_state,
      };
      this.$confirm('You will reject this whole request. You can not undo this action. Continue?', 'Confirmation', {
        type: 'info',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await this.$store.dispatch(REJECT_AWA, {
              id: item.company_id,
              data: obj,
            }).then(() => {
              this.$message({
                title: 'Success',
                type: 'success',
                message: 'Rejection success',
              });
              this.getList();
            }).catch((err) => {
              if (err.response?.data) popupErrorMessages(err.response.data);
            });
            instance.confirmButtonLoading = false;
          }
          done();
        },
      }).catch(() => {});
    },
    handlerBtnViewInvoice(company_id, company_name) {
      this.$router.push({
        name: 'AWA Invoice',
        params: {
          id: company_id,
          company_name: company_name
        },
      });
    },
    // async ewaBalance() {
    //   this.loading.balance = true;
    //   const { data } = await this.$store.dispatch(CHECK_EWA_BALANCE);
    //   this.ewa_balance = data.balance.balance;
    //   this.loading.balance = false;
    // },
  },
};
</script>
<style>
.el-range-separator {
  width: 10% !important;
}
</style>